import { createSlice } from '@reduxjs/toolkit';
import initState from '../../../domain/entities/trackingCase';

// GETALL
function getAll(state, action) {
  state.getAll.data = action.payload.data ? action.payload.data:[];
}

function conexionGetAll(state, action) {
  state.getAll.connection= action.payload.connection;
}

function errorGetAll(state, action) {
  state.getAll.error= action.payload.error ? action.payload.error:false;
  state.getAll.message= action.payload.message ? action.payload.message:"";
}


/**
 * Conexión
 */
const trackingCaseReducer = createSlice({
  name: 'trackingCase',
  initialState: initState,
  reducers: {
    // GETALL
    getAll,
    conexionGetAll,
    errorGetAll,
  },
});

export const trackingCaseActions = {
  ...trackingCaseReducer.actions,
};

export default trackingCaseReducer.reducer;
